export class ChaseProfileTransactionData {
    ChaseOrderId: string;
    TransactionAmount: string;
    ProfileReference: string;
    PaymentType: string;
}
